import { Component } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { ChecklistReportListData, ChecklistReportListDataService } from './checklist-report-list-data.service';
import { ChecklistReportService } from '../checklist-report.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { SideListOptionType } from '@fi-shared/types/side-list-option-type';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ILightWeightObjectCollection } from '@fi-shared/models';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { IItemsListParameterBase, ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { FiLocalSearchGroupType } from '@fi-shared/fi-local-search2/fi-local-search-group-type';

@Component({
    selector: 'fi-checklist-report-list',
    templateUrl: './checklist-report-list.component.html',
    styleUrls: ['./checklist-report-list.component.scss'],
    standalone: false,
})
export class ChecklistReportListComponent extends ItemsListContainerBase<ChecklistReportListData> {
    sideListOptionsTopChecklist: ISideListOptionsItem[] = [];
    FiStateNames = FiStateNames;

    constructor(
        private checklistReportListDataService: ChecklistReportListDataService,
        private checklistReportService: ChecklistReportService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private appTextService: AppTextService,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(
            () => {
                return this.checklistReportListDataService.getInstance();
            },
            { showDelete: false },
        );

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
        this.initSideList();
    }

    private initSideList(): void {
        this.sideListOptionsTopChecklist = [
            { value: SideListOptionType.SharedWithMe, text: this.appTextService.get('checklist.all_checklists') },
            { value: SideListOptionType.Active, text: this.appTextService.get('checklist.active_checklists') },
            { value: SideListOptionType.Inactive, text: this.appTextService.get('checklist.inactive_checklists') },
            { value: SideListOptionType.Expired, text: this.appTextService.get('checklist.ended_checklists') },
        ];
        // "My checklists" is not allowed for "read" users
        if (
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.ChecklistLocal,
                AccessRightType.Write,
            )
        ) {
            this.sideListOptionsTopChecklist.splice(1, 0, {
                value: SideListOptionType.CreatedBy,
                text: this.appTextService.get('checklist.my_checklists'),
            });
        }

        if (this.ListData.Statefull) this.ListData.setFromStateFilterType(this.sideListOptionsTopChecklist);
    }

    private getParameterApiModel() {
        const result: IItemsListParameterBase = {
            SelectedSort: {
                ColumnName: this.ListData.Sort.Column,
                SortDirection: this.ListData.Sort.Reverse,
            },
            Names: [],
            Ids: [],
            FilterType: this.ListData.FilterType,
        };

        Object.assign(result, this.ListData.getOffsetParams());

        this.ListData.mergeLocalSearchV2Parameter(result);

        return result;
    }

    protected LoadItems(): Promise<void> {
        const fetchingAllData = this.ListData.fetchingAllData;
        const parameter = this.getParameterApiModel();
        parameter.FetchParams = {
            FetchItems: true,
            FetchTotalCount: fetchingAllData,
            FetchLightWeightObjects: fetchingAllData,
        };
        return this.checklistReportService.getCheckListReportsListData(parameter).then((response) => {
            this.ListData.appendData(response.Items);

            if (fetchingAllData) {
                this.ListData.SetTotalItemsCount(response.TotalCount);

                const lightWeightObjectCollection = response.LightWeightObjectsForLocalSearch;
                if (lightWeightObjectCollection) {
                    this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
                }
            }
        });
    }
}
